import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { RouterName } from '@/enums/router-name'
import { useAuthStore } from '@/stores/use-auth-store'
import { useUserProfileStore } from '@/stores/use-user-profile-store'

export function authGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void {
  const {
    isTokenEmpty,
    isLangEmpty,
    setTokenDataByCookies,
    resetTokenData,
    setLangByCookies
  } = useAuthStore()
  const { hasUserInfo, resetUserInfo, setUserInfoByCookies } =
    useUserProfileStore()

  // Token Store 為空時，從 Cookies 取得資料寫入 Store 並回傳有沒有寫入成功
  const tokenRestored = isTokenEmpty ? setTokenDataByCookies() : true

  // 使用者資料 Store 為空時，從 Cookies 取得資料寫入 Store 並回傳有沒有寫入成功
  const userInfoRestored = !hasUserInfo ? setUserInfoByCookies() : true

  // 如果語系為空，則從 Cookies 取得語系資料寫入 Store
  if (isLangEmpty) {
    setLangByCookies()
  }

  // if (authStore.isCookiesTokenEmpty()) {
  //   authStore.setTokenCookies()
  // }

  // 如果 [Token] 或 [使用者資料] 為空時，重設兩者資料後導回首頁
  if (!tokenRestored || !userInfoRestored) {
    resetTokenData()
    resetUserInfo()
    next({ name: RouterName.LOGIN })
  }

  next()
}
